import { Observable } from 'rxjs';
import { SampleSelection } from '../../model/sample-selection/sample-selection.model';
import { SampleSelectionQueryParams } from '../../model/sample-selection/sample-selection-query-params.model';
import { PaginatedResponse } from '../../model/common/pagination.model';

// Re-export for backward compatibility
export type { SampleSelectionQueryParams } from '../../model/sample-selection/sample-selection-query-params.model';

/**
 * Abstract repository for Sample Selection domain entity
 * Defines the contract for accessing sample selection data
 *
 * HU32-922499: Selección de muestras para procesamiento
 *
 * Implementation should be provided in infrastructure layer
 * following the Dependency Inversion Principle
 */
export abstract class SampleSelectionRepository {
  /**
   * Get paginated list of samples for selection
   * @param params Query parameters for filtering and pagination
   * @returns Observable of paginated samples
   */
  abstract findAll(
    params?: SampleSelectionQueryParams
  ): Observable<PaginatedResponse<SampleSelection>>;

  /**
   * Confirm sample selection for processing
   * @param request Selection confirmation request
   * @returns Observable with confirmation result
   */
  abstract confirmSelection(request: {
    technology: string;
    lgCodes: string[];
    maxLimit: number;
    selectedBy: string;
  }): Observable<SelectionConfirmation>;

  /**
   * Get valid selection limits (multiples of 12 from 12 to 384)
   * @returns Observable with array of valid limits
   */
  abstract getSelectionLimits(): Observable<number[]>;
}

/**
 * Selection confirmation result
 */
export interface SelectionConfirmation {
  readonly selectionId: string;
  readonly technology: string;
  readonly selectedCount: number;
  readonly maxLimit: number;
  readonly status: string;
  readonly createdAt: string;
}

/**
 * @deprecated Use SampleSelectionRepository instead
 */
export abstract class LaboratoryRepository extends SampleSelectionRepository {}
